import React from 'react';
import { WorkflowState } from '../../../models/enums/WorkflowState';
import { PortOpeningRequestsDirection } from '../../../models/enums/POR/PortOpeningRequestsDirection';
import WorkflowStateBadge from '../../common/WorkflowStateBadge';
import './ProgressBarBig.css';
import PortOpeningRequestOnPrem from '../../../models/entities/PortOpeningRequestSiteToSiteOnPrem';

interface ProgressBarBigProps {
    workflowState: WorkflowState;
    por: PortOpeningRequestOnPrem;
}

const ProgressBarBig = ({ workflowState, por }: ProgressBarBigProps) => {
    const hasProgressBar = (): boolean => {
        const noProgressArray = [WorkflowState.Cancelled, WorkflowState.Rejected];
        return !noProgressArray.some((nws) => nws.value === workflowState.value);
    };

    const activePolicyTeamApproval = () => {
        switch (workflowState.value) {
            case WorkflowState.PendingAccountOwnerApproval.value:
            case WorkflowState.PendingForDOAGApproval.value:
            case WorkflowState.AwaitingImplementation.value:
            case WorkflowState.Completed.value:
            case WorkflowState.Error.value:
                return "big-back-blue";
            default:
                return "";
        }
    };

    const activeOwnerApproval = () => {
        switch (workflowState.value) {
            case WorkflowState.PendingForDOAGApproval.value:
            case WorkflowState.AwaitingImplementation.value:
            case WorkflowState.Completed.value:
            case WorkflowState.Error.value:
                return "big-back-blue";
            default:
                return '';
        }
    };


    return (
        <>
            <div className="big-progress-bar__title">
                <span className="em-c-field__label em-c-field__label--margin">Status</span>
                <WorkflowStateBadge workflowState={workflowState} />
            </div>
            {hasProgressBar() && (
                <div className="big-progress-bar">
                    <div className="big-progress-bar__line" />
                    <div className="big-progress-bar__circle-with-title big-left-0">
                        <div className={`big-progress-bar__circle ${activePolicyTeamApproval()}`}>✓</div>
                        <div className="big-progress-bar__circle--title">Policy Team Approval</div>
                    </div>
                    <div className={`big-progress-bar__circle-with-title big-left-100`}>	
                        <div className={`big-progress-bar__circle ${activeOwnerApproval()}`}>✓</div>
                        <div className="big-progress-bar__circle--title">Owner Approval</div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ProgressBarBig;